import { ChangeEvent, HTMLAttributes } from 'react'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import dayjs from 'dayjs'

dayjs.extend(customParseFormat)

interface ToggleInputProps extends HTMLAttributes<HTMLInputElement> {
  value?: boolean
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
}

const ToggleInput = ({ value, onChange, ...rest }: ToggleInputProps) => {
  return (
    <div className="toggle">
      <input
        {...rest}
        type="checkbox"
        className="toggle-input"
        checked={value}
        onChange={onChange}
      />
      <span className="toggle-slider" />
    </div>
  )
}

export default ToggleInput
